import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {QUESTION_EDIT_MODE, QUESTION_LIST_MODE} from "@irati/insights/constants/question"
import {QUESTION_EDIT_DISABLED_COLOR} from "../../../ui/colors"
import {Tooltip} from "../../../ui/Tooltip"
import {Para} from "../../../ui/Labels"
import {
  Wrapper,
  QuestionWrapper,
  IconButton,
  IconWrapper,
  InputWrapper,
  StyledInput,
  ActionButton,
  ButtonWrapper} from "./QuestionEditorStyles"

const PROPERTY = "preferences.driverCommentTitle"
const TOGGLE_PROPERTY = "preferences.includeDriverComment"

const QuestionText = styled(Para)`
  ${({disabled}) => (disabled) && `
    color: ${QUESTION_EDIT_DISABLED_COLOR};
  `}
`

class OpenFeedback extends Component {
  state = {
    driverCommentTitle: "",
    mode: QUESTION_LIST_MODE
  }

  static propTypes = {
    cycle: PropTypes.object,
    className: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    cycle: {},
    className: "",
    questions: {},
    disabled: false
  }

  componentDidMount() {
    const {cycle: {preferences: {driverCommentTitle}}} = this.props
    this.setState({driverCommentTitle})
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.mode === QUESTION_EDIT_MODE) {
      const {cycle: {preferences: {driverCommentTitle}}} = props
      return {driverCommentTitle}
    }
    return null
  }

  handleChange = (driverCommentTitle) => {
    this.setState({driverCommentTitle})
  }

  handleSave = () => {
    const {onChange} = this.props
    const {driverCommentTitle} = this.state
    onChange(null, PROPERTY, driverCommentTitle)
    this.setListMode()
  }

  handleCancel = () => {
    const {cycle: {preferences: {driverCommentTitle}}} = this.props
    this.setState({driverCommentTitle, mode: QUESTION_LIST_MODE})
  }

  setEditMode = () => {
    const {disabled} = this.props
    const includeDriverComment = get(this.props.cycle, TOGGLE_PROPERTY)
    if (!disabled) return includeDriverComment ? this.setState({mode: QUESTION_EDIT_MODE}) : this.setState({mode: QUESTION_LIST_MODE})
  }

  setListMode = () => {
    this.setState({mode: QUESTION_LIST_MODE})
  }

  handleToggle = () => {
    const {disabled} = this.props
    const {onChange, cycle} = this.props
    const includeDriverComment = get(cycle, TOGGLE_PROPERTY)
    if (!disabled) onChange(null, TOGGLE_PROPERTY, !includeDriverComment)
  }

  getHideOrShowStyles = (includeDriverComment) => {
    const {formatMessage} = this.props
    if (includeDriverComment) {
      return {
        toolTipText: formatMessage({id: "insights.customSurvey.openFeedback.hide"}),
        showIcon: "eyeSlash",
        editIcon: "editQuestion"
      }
    }
    return {
      toolTipText: formatMessage({id: "insights.customSurvey.openFeedback.show"}),
      showIcon: "eye",
      editIcon: "disabledEditQuestion",
      disabled: true
    }
  }

  render() {
    const idNamespace = id("OpenFeedback", this.props)
    const {cycle, className, formatMessage, disabled} = this.props
    const {mode, driverCommentTitle} = this.state
    const {uuid} = cycle
    const includeDriverComment = get(cycle, TOGGLE_PROPERTY)
    const intlPlaceholder = formatMessage({id: "insights.customSurvey.questionInput.placeholder"})
    const getHideOrShowStyles = this.getHideOrShowStyles(includeDriverComment)

    return (
      <Wrapper key={uuid}>
        <QuestionWrapper>
          {mode === QUESTION_LIST_MODE &&
            <>
              <QuestionText
                medium
                flush
                disabled={disabled || getHideOrShowStyles.disabled}>
                {driverCommentTitle}
              </QuestionText>
              <IconWrapper>
                <IconButton
                  disabled={disabled}
                  id={id("iconEdit", idNamespace)}
                  onClick={this.setEditMode}
                  icon={getHideOrShowStyles.editIcon}
                  size={18} />
                <Tooltip tooltipChildren={getHideOrShowStyles.toolTipText} placement="top">
                  <IconButton
                    disabled={disabled}
                    id={id("iconShow", idNamespace)}
                    onClick={this.handleToggle}
                    icon={getHideOrShowStyles.showIcon}
                    size={22} />
                </Tooltip>
              </IconWrapper>
            </>
          }
          {mode === QUESTION_EDIT_MODE &&
            <InputWrapper>
              <StyledInput
                wide
                type="text"
                placeholder={intlPlaceholder}
                name="addQuestion"
                value={driverCommentTitle}
                onChange={this.handleChange}
                className={`${className} clearfix`}
                label="" />
              <ButtonWrapper>
                <ActionButton marginBottom secondary small onClick={this.handleCancel}>
                  <FormattedMessage id="insights.customSurvey.questionCta.cancel" />
                </ActionButton>
                <ActionButton primary small onClick={this.handleSave}>
                  <FormattedMessage id="insights.customSurvey.questionCta.save" />
                </ActionButton>
              </ButtonWrapper>
            </InputWrapper>
          }
        </QuestionWrapper>
      </Wrapper>
    )
  }
}

export default injectIntl(OpenFeedback)
